var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"支付结果"}},[_c('x-card',{class:_vm._.success},[_c('div',{class:_vm._.content},[_c('van-icon',{class:_vm._.icon,attrs:{"name":"checked"}}),_vm._v(" 支付成功 ")],1)]),_c('GroupBuyingView',{attrs:{"id":_vm.query.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }